import { Component, OnInit, OnDestroy } from '@angular/core';
import { Role } from 'src/app/shared/models/role.model';
import { Company, CompanyType } from 'identity-webapi-client';
import { Subscription } from 'rxjs';
import { AuthService, StateService } from '../services';

@Component({
  template: '', // Placeholder template
})
export class SituBaseComponent implements OnInit, OnDestroy {
  isAdmin: boolean = false;
  isSituUser: boolean = false;
  isReleaseUser: boolean = false;
  isPartnerAdmin: boolean = false;
  isExternalProductContractorUser: boolean = false;
  isCompanyProductPublisherUser: boolean = false;

  isDarkMode: boolean = false;
  selectedCompany: Company | undefined;

  _subscriptions: Subscription[] = [];

  constructor(
    public authService: AuthService,
    public stateService: StateService
  ) { }

  ngOnInit(): void {
    this._subscriptions.push(this.authService.userSubject.subscribe(x => {
      const newIsAdmin = this.authService.hasAnyRole([Role.Admin, Role.BuilderAdmin]);
      const newIsSituUser = this.authService.hasSituAccess();
      const newIsReleaseUser = newIsSituUser || this.authService.hasAnyRole([Role.Admin, Role.BuilderAdmin, Role.Release]);
      const newIsExternalProductContractorUser = this.authService.hasRole(Role.ExternalProductContractor);
      const isCompanyProductPublisherUser = this.authService.hasRole(Role.CompanyProductPublisher);
      const newIsPartnerAdmin = this.authService.hasRole(Role.PartnerAdmin);
  
      if (this.isAdmin !== newIsAdmin) {
        this.isAdmin = newIsAdmin;
      }
  
      if (this.isSituUser !== newIsSituUser) {
        this.isSituUser = newIsSituUser;
      }
  
      if (this.isExternalProductContractorUser !== newIsExternalProductContractorUser) {
        this.isExternalProductContractorUser = newIsExternalProductContractorUser;
      }
  
      if (this.isCompanyProductPublisherUser !== isCompanyProductPublisherUser) {
        this.isCompanyProductPublisherUser = isCompanyProductPublisherUser;
      }

      if (this.isReleaseUser !== newIsReleaseUser) {
        this.isReleaseUser = newIsReleaseUser
      }

      if (this.isPartnerAdmin !== newIsPartnerAdmin) {
        this.isPartnerAdmin = newIsPartnerAdmin
      }

      this.onUserChange();
    }));
  
    this._subscriptions.push(this.stateService.state$.subscribe((state) => {
      const newIsDarkMode = state?.useDarkTheme ?? false;
      if (this.isDarkMode !== newIsDarkMode) {
        this.isDarkMode = newIsDarkMode;
      }
  
      if (state?.company?.id && this.selectedCompany?.id !== state?.company?.id) {
        this.selectedCompany = state?.company;
        this.onSelectedCompanyChange();
      }
    }));
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected onSelectedCompanyChange(): void {
    // Method to be overridden in the derived component
    // Perform the desired action in the derived component
  }

  protected onUserChange(): void {
    // Method to be overridden in the derived component
    // Perform the desired action in the derived component
  }
}